import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AdaptiveAccessNodeRuleset } from "@aptsi-types";
import { environment } from "@env";
import { BehaviorSubject, Observable } from "rxjs";
import { catchError, filter, map } from "rxjs/operators";
import { ErrorHandlingService } from "../../shared/errorHandling/errorHandling.service";
import { API_ENDPOINTS } from "../../ada-access-api-endpoints";
import { NavigationEnd, Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class AdaptiveAccessNodeRulesetService {
  private readonly adaptiveAccessNodeUrl = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private errorHandlingService: ErrorHandlingService,
     private router: Router,
  ) {

     this.router.events
          .pipe(
            filter((event) => event instanceof NavigationEnd) 
          )
          .subscribe(() => {
            this.nodeRulesets.next([]); 
          });
  }

   private existingAdaptiveAccessNodeRulesetId: string =null;

   public nodeRulesets = new BehaviorSubject<any[]>([]);
  
   nodeRulesets$ = this.nodeRulesets.asObservable();

   addNodeRulesets(entry:any){
    const currentNodes = this.nodeRulesets.value; 
    this.nodeRulesets.next([...currentNodes , entry]);
   }

  getAdaptiveAccessNodeRulesets(
    nullver: number
  ): Observable<AdaptiveAccessNodeRuleset[]> {
    return this.http
      .post<{ accessflowrulesets: AdaptiveAccessNodeRuleset[] }>(
        `${this.adaptiveAccessNodeUrl}${API_ENDPOINTS.ADAPTIVE_ACCESS_NODE_RULESET.FETCH}`,
        { nullver }
      )
      .pipe(
        map((response) => response.accessflowrulesets),
        catchError((error) => this.errorHandlingService.handleError(error))
      );
  }

  getAdaptiveAccessNodeRuleset(
    adaptiveaccessnoderulesetid: string
  ): Observable<AdaptiveAccessNodeRuleset> {
    return this.http
      .post<{ accessflowruleset: AdaptiveAccessNodeRuleset }>(
        `${this.adaptiveAccessNodeUrl}${API_ENDPOINTS.ADAPTIVE_ACCESS_NODE_RULESET.GET}`,
        { adaptiveaccessnoderulesetid }
      )
      .pipe(
        map((response) => response.accessflowruleset),
        catchError((error) => this.errorHandlingService.handleError(error))
      );
  }

  getAdaptiveAccessNodeRulesetByaccessNodeId(
    adaptiveaccessnodeid: string
  ): Observable<AdaptiveAccessNodeRuleset> {
    return this.http
      .post<{ accessflowruleset: AdaptiveAccessNodeRuleset }>(
        `${this.adaptiveAccessNodeUrl}${API_ENDPOINTS.ADAPTIVE_ACCESS_NODE_RULESET.GET_BY_ADAPTIVE_ACCESS_NODE__ID}`,
        { adaptiveaccessnodeid }
      )
      .pipe(
        map((response) => response.accessflowruleset),
        catchError((error) => this.errorHandlingService.handleError(error))
      );
  }


  getAdaptiveAccessNodeRulesetStage(
  ): Observable<AdaptiveAccessNodeRuleset[]> {
    return this.http
      .post<{ accessflowrulesets: AdaptiveAccessNodeRuleset[] }>(
        `${this.adaptiveAccessNodeUrl}${API_ENDPOINTS.ADAPTIVE_ACCESS_NODE_RULESET.FETCHSTAGE}`,
        { }
      )
      .pipe(
        map((response) => response.accessflowrulesets),
        catchError((error) => this.errorHandlingService.handleError(error))
      );
  }


  getAdaptiveAccessNodeRulesetId() : string {
    return this.existingAdaptiveAccessNodeRulesetId;
  }   
     

  createAdaptiveAccessNodeRuleset(
    adaptiveaccessnodeid: string,
    rulesetid: string,
    rulesettype: string,
  ): Observable<AdaptiveAccessNodeRuleset> {
    return this.http
      .post<AdaptiveAccessNodeRuleset>(
        `${this.adaptiveAccessNodeUrl}${API_ENDPOINTS.ADAPTIVE_ACCESS_NODE_RULESET.CREATE}`,
        {   
          adaptiveaccessnodeid,
          rulesettype,
          rulesetid,
        }
      )
      .pipe(
        map((response:any) => {
          this.existingAdaptiveAccessNodeRulesetId=response["Resource created successfully"].adaptiveaccessnoderulesetid;
          return response["Resource created successfully"];
        }),
        catchError((error) => this.errorHandlingService.handleError(error))
      );
  }

  createAdaptiveAccessNodeRulesetForUpdateScreen(
    adaptiveaccessnodeid: string,
    rulesetid: string,
    rulesettype: string,
  ): Observable<AdaptiveAccessNodeRuleset> {
    return this.http
      .post<AdaptiveAccessNodeRuleset>(
        `${this.adaptiveAccessNodeUrl}${API_ENDPOINTS.ADAPTIVE_ACCESS_NODE_RULESET.CREATEFORUPDATE}`,
        {   
          adaptiveaccessnodeid,
          rulesettype,
          rulesetid,
        }
      )
      .pipe(
        catchError((error) => this.errorHandlingService.handleError(error))
      );
  }

  updateAdaptiveAccessNodeRuleset(
    adaptiveaccessnodeid: string,
    adaptiveaccessnoderulesetid: string,
    rulesettype: string,
    rulesetid: string
  ): Observable<AdaptiveAccessNodeRuleset> {
    return this.http
      .post<AdaptiveAccessNodeRuleset>(
        `${this.adaptiveAccessNodeUrl}${API_ENDPOINTS.ADAPTIVE_ACCESS_NODE_RULESET.UPDATE}`,
        {
          adaptiveaccessnodeid,
          adaptiveaccessnoderulesetid,
          rulesettype,
          rulesetid,
        }
      )
      .pipe(
        catchError((error) => this.errorHandlingService.handleError(error))
      );
  }

  deleteAdaptiveAccessNodeRuleset(
    accessflowrulesetid: string
  ): Observable<AdaptiveAccessNodeRuleset[]> {
    return this.http
      .post<AdaptiveAccessNodeRuleset[]>(
        `${this.adaptiveAccessNodeUrl}${API_ENDPOINTS.ADAPTIVE_ACCESS_NODE_RULESET.DELETE}`,
        { accessflowrulesetid }
      )
      .pipe(
        catchError((error) => this.errorHandlingService.handleError(error))
      );
  }

  deleteAdaptiveAccessNodeRulesetStage(
    rulesetId: string
  ): Observable<AdaptiveAccessNodeRuleset[]> {
    return this.http
      .post<AdaptiveAccessNodeRuleset[]>(
        `${this.adaptiveAccessNodeUrl}${API_ENDPOINTS.ADAPTIVE_ACCESS_NODE_RULESET.DELETESTAGE}`,
        { rulesetId }
      )
      .pipe(
        catchError((error) => this.errorHandlingService.handleError(error))
      );
  }
}
